import {
  CompletionTargetUnit,
  FrequencyUnit,
  HabitSchedule,
  RecurrenceFormUnit,
  RruleReferenceDate,
} from '@griply/types';

import { parseFormUnitFromRrule } from './parse-rrule';

export const parseRruleAndCountToSchedule = (
  rrule: string,
  count: number | null,
  today: Date,
): HabitSchedule => {
  const formUnit = parseFormUnitFromRrule(rrule);

  return {
    startDate: today,
    frequency: count
      ? {
          count,
          unit:
            formUnit === RecurrenceFormUnit.Weeks
              ? FrequencyUnit.Week
              : FrequencyUnit.Month,
        }
      : null,
    rrule: {
      format: rrule,
      referenceDate: RruleReferenceDate.StartDate,
    },
    completionTarget: {
      unit: CompletionTargetUnit.Day,
      count: 1,
    },
    entries: [],
    completions: [],
  };
};
